module.exports = __webpack_public_path__ + "img/fank.16879981.png";